module.exports = __webpack_public_path__ + "img/process_success.8be38c0a.svg";